import { makeObservable, observable } from 'mobx';
import PointBasedRuleDataModel from './PointBasedRuleDataModel';

export default class GroupPointBasedRulesDataModel {
  rules: PointBasedRuleDataModel[];

  number: number;

  /**
   * What the group is called on screen. Optional: groups saved before names
   * existed have none, and are shown by what their first rule reads.
   */
  name?: string;

  constructor(
    number?: number,
    rules?: PointBasedRuleDataModel[],
    name?: string
  ) {
    if (number && rules) {
      this.number = number;
      this.rules = rules;
    } else {
      this.number = 1;
      this.rules = [];
    }
    // Carried through here because the store builds every group through this
    // constructor when it loads them, and the unflagged Rules page saves those
    // objects back: without it, that page would drop a name the new page set.
    if (name) this.name = name;
    makeObservable(this, {
      rules: observable,
      number: observable,
      name: observable,
    });
  }
}
